import script from "./OfOnboardingResult.vue?vue&type=script&setup=true&lang=js"
export * from "./OfOnboardingResult.vue?vue&type=script&setup=true&lang=js"

import "./OfOnboardingResult.vue?vue&type=style&index=0&id=e63fd92c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e63fd92c"]])

export default __exports__